import { toValue } from 'vue'
import { useMutation, useQuery } from '@tanstack/vue-query'
import { queryClient } from '@/plugins/tanstack'
import { saveCaseCardsConfiguration } from '@/common/services/UsersService'
import caseLayoutItemServerData from '@/common/services/serverData/caseLayoutItemServerData'
import { queryKeyFactory } from '@/common/services/serverData/serverDataManager'
import { type CaseColumnConfigurationDTOV1 } from '@/common/types/case'
import { SERVER_DATA_SCOPE, SERVER_DATA_TYPE, type ServerDataComposableOptionsBase } from '@/common/types/cacheConstants'

type UseCaseLayoutItemServerDataOptions<TResult> = ServerDataComposableOptionsBase<TResult, CaseColumnConfigurationDTOV1[]>

export const useCaseLayoutItemServerData = <TResult = CaseColumnConfigurationDTOV1[]>(options: UseCaseLayoutItemServerDataOptions<TResult> = {}) => {
  const { select, enabled = true, staleTime } = options

  const query = useQuery({
    ...caseLayoutItemServerData.groupOptions({ staleTime }),
    select,
    enabled: () => !!toValue(enabled),
  })

  const { mutate, mutateAsync } = useMutation({
    mutationFn: (variables: CaseColumnConfigurationDTOV1[]) => saveCaseCardsConfiguration(variables),
    onSuccess: (data, columns) => {
      queryClient.setQueryData(
        queryKeyFactory({
          scope: SERVER_DATA_SCOPE.CASE_LAYOUT,
          type: SERVER_DATA_TYPE.ITEM,
        }),
        columns,
      )
    },
  })

  return {
    ...query,
    mutate,
    mutateAsync,
  }
}
